import React from "react";
import { Button } from "@material-ui/core";

import { BackButtonWrapper } from "./styles";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";

const TopControls = ({ text, onBackClick }: any) => {
  return (
    <BackButtonWrapper>
      <Button
        color="secondary"
        variant="text"
        startIcon={<KeyboardBackspaceIcon />}
        onClick={onBackClick}
      >
        {text}
      </Button>
    </BackButtonWrapper>
  );
};

export default TopControls;
